import React, { Component } from 'react';

class IconSidebarItemNews extends Component {
    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
            >
                <path
                    fill={this.props.isActive ? "#26A" : "#424242"}
                    stroke={this.props.isActive ? "#26A" : "#424242"}
                    d="M2.952 7.506v0h.01c.214-.005.442.187.442.498v10c0 .807.624 1.498 1.452 1.498H17.24c.23 0 .452.197.452.5 0 .3-.221.498-.452.498H3.904c-.384 0-.638-.099-.814-.222-.18-.126-.309-.3-.4-.492a2.044 2.044 0 01-.19-.777V19h0l-.5.001h.5V8.004c0-.301.222-.498.452-.498zM21.5 4.548h0v10.903c0 .572-.477 1.053-1.116 1.053H7.424c-.637 0-1.116-.49-1.116-1.053V4.554c0-.56.485-1.054 1.125-1.054h12.961c.638 0 1.112.49 1.106 1.048zm-.894 9.45V5.997c0-.795-.622-1.5-1.452-1.5H8.674c-.828 0-1.453.692-1.453 1.5v8c0 .809.625 1.5 1.452 1.5h10.48c.828 0 1.453-.691 1.453-1.5zM9.625 6.497h.952c.23 0 .452.197.452.499v2.996c0 .302-.222.499-.452.499h-.952c-.23 0-.452-.197-.452-.499V6.996c0-.296.225-.5.452-.5zm8.577 7H9.625c-.23 0-.452-.196-.452-.498s.222-.499.452-.499h8.577c.23 0 .452.197.452.499 0 .298-.228.499-.452.499zm0-5.993h-3.808c-.23 0-.452-.197-.452-.498 0-.302.222-.5.452-.5h3.808c.23 0 .452.198.452.5 0 .291-.232.498-.452.498zm0 2.997h-3.808c-.23 0-.452-.197-.452-.499s.222-.499.452-.499h3.808c.23 0 .452.197.452.5 0 .29-.232.498-.452.498z"
                ></path>
            </svg>
        );
    }
}

export default IconSidebarItemNews;